import type { SxProps, Theme } from '@mui/material/styles';

type NotificationsPageStyleMap = {
    root: SxProps<Theme>
    header: SxProps<Theme>
    filtersPaper: SxProps<Theme>
    toggleButton: SxProps<Theme>
    listPaper: SxProps<Theme>
};

export const notificationsPageStyles: NotificationsPageStyleMap = {
    root: { maxWidth: 720, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 },
    header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' },
    filtersPaper: { border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1 },
    toggleButton: { textTransform: 'none' },
    listPaper: { border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden' },
};
